import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { HERO_IMAGE } from '../mock';

export default function Hero() {
  return (
    <section className="relative pt-32 pb-24 overflow-hidden">
      <div className="absolute inset-0 dot-grid opacity-70" />
      <div className="absolute inset-x-0 bottom-0 h-[380px] yellow-glow" />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] uppercase text-neutral-600 mb-6">
            <span className="h-px w-8 bg-neutral-400" />
            Build A System With <span className="text-black font-black">XXPAND</span>
          </div>

          <h1 className="text-[44px] md:text-[58px] leading-[1.05] font-black text-black mb-6">
            Manage, Automate, and Scale &mdash;{' '}
            <span className="relative inline-block">
              <span className="relative z-10">All in One CRM</span>
              <span className="absolute left-0 right-0 bottom-1 h-3 bg-[#22c55e] -z-0 rounded" />
            </span>{' '}
            For Growing Businesses
          </h1>

          <p className="text-lg text-neutral-600 max-w-xl mb-8 leading-relaxed">
            Everything your growing business needs in one place. With 26+ integrated tools across your core departments, you can build scalable systems, eliminate complexity, and manage growth from a single platform.
          </p>

          <div className="flex flex-wrap gap-4 mb-6">
            <button className="cta-btn group inline-flex items-center gap-2 px-8 py-4 bg-black text-white rounded-full font-bold text-[15px] shadow-lg">
              Start 14 Day Trial
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
            <button className="cta-btn inline-flex items-center gap-2 px-8 py-4 bg-white text-black border-2 border-black rounded-full font-bold text-[15px]">
              Watch Demo
            </button>
          </div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-neutral-500 italic">
            <span className="inline-flex items-center gap-1.5"><CheckCircle2 className="w-4 h-4 text-neutral-400" /> No credit card required</span>
            <span className="inline-flex items-center gap-1.5"><CheckCircle2 className="w-4 h-4 text-neutral-400" /> Setup in minutes</span>
            <span className="inline-flex items-center gap-1.5"><CheckCircle2 className="w-4 h-4 text-neutral-400" /> Cancel anytime</span>
          </div>
        </div>

        <div className="relative">
          <div className="relative float-hero">
            <div className="absolute -inset-4 bg-gradient-to-br from-[#22c55e]/30 via-transparent to-transparent rounded-[3rem] blur-2xl" />
            <div className="relative rounded-[2rem] overflow-hidden bg-white shadow-2xl border border-neutral-100">
              <img src={HERO_IMAGE} alt="Business automation illustration" className="w-full h-[520px] object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#22c55e]/10 via-transparent to-transparent" />
            </div>

            {/* Floating badges */}
            <div className="absolute -top-4 -left-4 bg-white rounded-2xl shadow-xl px-4 py-3 border border-neutral-100 hidden md:flex items-center gap-2">
              <div className="w-9 h-9 rounded-lg bg-[#22c55e] flex items-center justify-center font-black text-black">26+</div>
              <div>
                <div className="text-[11px] text-neutral-500 font-semibold">TOOLS</div>
                <div className="text-sm font-bold text-black">Integrated</div>
              </div>
            </div>
            <div className="absolute -bottom-4 -right-4 bg-black rounded-2xl shadow-xl px-4 py-3 hidden md:flex items-center gap-2">
              <div className="w-9 h-9 rounded-lg bg-[#22c55e] flex items-center justify-center">
                <CheckCircle2 className="w-5 h-5 text-black" />
              </div>
              <div>
                <div className="text-[11px] text-neutral-400 font-semibold uppercase tracking-wider">Trusted</div>
                <div className="text-sm font-bold text-white">80+ Businesses</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
